<template>
  <div class="transparent-tab">
    <div class="transparent-tab-btn-right" v-if="!visible">
      <a-button shape="round" icon="caret-right" type="primary" @click="handleOpenOrClose"></a-button>
    </div>
    <div class="transparent-tab-btn-left" v-else>
      <a-button shape="round" icon="caret-left" type="primary" @click="handleOpenOrClose"></a-button>
    </div>
    <div class="transparent-tab-wrapper" v-show="visible">
      <div class="m-panel-body">
        <!-- 提取的树形组件内容 -->
        <div class="m-panel-body-sub">
          <a-alert type="info" :showIcon="true" class="dark-alert">
            <div slot="message" class="alert-message">
              {{ $t('当前选择：') }}<span v-if="currSelected.name" class="selected-name">{{ currSelected.name }}</span>
              <a v-if="currSelected.name" class="unselect-link" @click="unselect">{{ $t('取消选择') }}</a>
            </div>
          </a-alert>
          <div class="tree-controls">
            <a-input-search v-model="searchAreaValue" class="tree-search" allowClear :placeholder="$t('请输入分区名称')" />
            <a-button type="default" class="tree-button" @click="handleAreaAdd">{{ $t('新增一级片区') }}</a-button>
          </div>
          <!-- 树形结构 -->
          <a-col :md="24" :sm="24" class="new-tree-col">
            <template>
              <a-spin tip="Loading..." :spinning="areaLoading">
                <el-tree
                  class="dark-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree"
                >
                  <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span class="tree-node-label">{{ node.label }}</span>
                    <span class="tree-node-actions">
                      <el-button
                        type="text"
                        size="mini"
                        icon="el-icon-plus"
                        class="tree-action-button"
                        @click="handleAdd(node, data)"
                      ></el-button>
                      <el-button
                        type="text"
                        size="mini"
                        icon="el-icon-delete"
                        class="tree-action-button"
                        @click="handleDelete(node, data)"
                      ></el-button>
                    </span>
                  </span>
                </el-tree>
              </a-spin>
            </template>
          </a-col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AreaTreeCard',
  props: {
    areaLoading: Boolean,
    areaTree: Array,
    currSelected: Object,
  },
  data() {
    return {
      visible: true,
      title: this.$t('分区树'),
      width: 800,
      disableSubmit: false,
      confirmLoading: false,
      searchAreaValue: '',
      defaultProps: {
        children: 'areaList',
        label: 'name',
        value: 'code',
      },
      checkStrictly: false,
      currentNodeKey: null,
      iExpandedKeys: [],
    }
  },
  watch: {
    searchAreaValue(val) {
      this.$refs.areaTree.filter(val)
    },
  },
  methods: {
    handleOpenOrClose() {
      this.visible = !this.visible
      this.$emit('toggle-visibility', this.visible)
    },

    // 树相关方法
    nodeClick(record, node) {
      this.currentNodeKey = record.code
      this.$refs.areaTree.setCheckedKeys([record.code])
      this.$emit('node-selected', record)
    },

    unselect() {
      this.$emit('unselect')
    },

    collapseAll() {
      this.$emit('collapse-all')
    },

    handleAreaAdd() {
      this.$emit('area-add')
    },

    handleAdd(node, data) {
      this.$emit('add-child', node, data)
    },

    handleDelete(node, data) {
      this.$emit('delete', node, data)
    },
    // 节点过滤方法（保持原样）
    filterNode(value, data) {
      if (!value) return true
      return data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    },
  },
}
</script>

<style lang="less" scoped>
.transparent-tab {
  width: 100%;
  position: absolute;
  top: 0;
}
.transparent-tab-wrapper {
  width: 320px;
  height: 422px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 6px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.5);
  padding: 0px;
  overflow: hidden;
}
.transparent-tab-btn-left {
  position: absolute;
  top: 206px;
  left: 328px;
  bottom: 0;
  z-index: 999;
  text-align: center;
  transform: rotate(90deg);
  ::v-deep .anticon {
    transform: rotate(-90deg);
  }
}
.transparent-tab-btn-right {
  position: absolute;
  left: -24px;
  top: 184px;
  z-index: 999;
  text-align: center;
  transform: rotate(90deg);
  ::v-deep .anticon {
    transform: rotate(-90deg);
  }
}

.m-panel-body {
  height: 100%;
}
/* 深色主题样式 */
.dark-alert {
  background-color: #2a2a2a;
  border: 1px solid #444;

  ::v-deep .ant-alert-message {
    color: #e0e0e0;
  }
}

.alert-message {
  color: #e0e0e0;
}

.selected-name {
  color: #1890ff;
  font-weight: bold;
}

.unselect-link {
  color: #ff7875;
  margin-left: 10px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.tree-controls {
  display: flex;
  margin-top: 10px;
  gap: 5px;
}

.tree-search {
  flex: 1;
  background: #333;
  border-color: #444;

  ::v-deep .ant-input {
    background: #333;
    color: #e0e0e0;
    border-color: #444;

    &::placeholder {
      color: #888;
    }
  }
}

.tree-button {
  background: #333;
  border-color: #444;
  color: #e0e0e0;

  &:hover {
    background: #444;
    border-color: #555;
  }
}

/* 深色树形结构 */
.dark-tree {
  background: #1f1f1f;
  color: #e0e0e0;
  margin-top: 10px;

  ::v-deep .el-tree-node {
    .el-tree-node__content {
      height: 36px;
      background: #2a2a2a;
      border-bottom: 1px solid #333;

      &:hover {
        background: #333;
      }
    }

    &.is-current > .el-tree-node__content {
      background: #153450;
    }
  }
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.tree-node-label {
  color: #e0e0e0;
}

.tree-node-actions {
  display: flex;
  gap: 5px;
}

.tree-action-button {
  color: #888;

  &:hover {
    color: #1890ff;
  }
}

::v-deep .ant-btn-primary {
  background-color: rgba(70, 76, 92, 0.8);
  border-color: rgba(70, 76, 92, 0.8);
}

.m-panel-body-sub {
  background-color: rgba(31, 31, 31, 0.3);
  padding: 10px;
  height: 100%;
  opacity: 0.75;
}
</style>
